/**
 * Trigger a file download via a hidden iframe.
 *
 * The browser navigates the iframe to the URL and handles redirects and the
 * final download natively, without involving JS or CORS checks. Used for
 * cross-origin endpoints that return a 302 redirect to a different host (e.g.
 * GCP Cloud Functions redirecting to storage.googleapis.com), where fetch +
 * blob would require both hosts to send proper CORS headers.
 *
 * Trade-off: there is no completion signal — the browser hands the download
 * off to its download manager and the page never knows when (or if) it
 * succeeded. Suitable when the UI does not need a "ready" state.
 *
 * The iframe is removed from the DOM after one hour to give slow endpoints
 * (heavy reports that take many minutes to start streaming) enough time
 * before cleanup, while still avoiding indefinite leaks.
 *
 * @param {string} url
 */
const downloadViaIframe = (url) => {
	const iframe = document.createElement('iframe');
	iframe.style.display = 'none';
	iframe.src = url;
	document.body.appendChild(iframe);
	setTimeout(() => iframe.remove(), 3600000);
}

export default downloadViaIframe;
